import { render, staticRenderFns } from "./GuideList.vue?vue&type=template&id=7966489c&scoped=true"
import script from "./GuideList.vue?vue&type=script&setup=true&lang=ts"
export * from "./GuideList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GuideList.vue?vue&type=style&index=0&id=7966489c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7966489c",
  null
  
)

export default component.exports